<operaciones-reembolso-actualizar #appoperacionesreembolso (TerminoGuardarRegistro)="TerminoGuardarOperacionesReembolso()"></operaciones-reembolso-actualizar>

<div class="d-flex flex-row mt-5">
    <div #contenedorprincipalbuscador class="buscarubicacion p-2">
        <div class="contenedorbusqueda d-flex align-items-start flex-column">
            <div class="mt-3 mb-auto p-2 d-flex flex-column">
                <div class="d-flex flex-row">
                    <mat-icon class="titulobusquedaicono" (click)="CancelarRegistro()">keyboard_arrow_left</mat-icon>
                    <h1 class="titulobusqueda">G-Maps</h1>
                </div>
                <div>
                    <div class="contenedorbuscador" [ngStyle]="{'width': AnchoBuscador(contenedorprincipalbuscador.offsetWidth - 50)}">
                        <div class="d-flex justify-content-between">
                            <div class="contenedorbuscadorsecundario" *ngIf="this.terminoCargarDefinicioDefecto">
                                <p class="textobuscador">Buscar en Google Maps (*)</p>
                                <input id="buscadorGoogle" class="inputbuscador" ngx-google-places-autocomplete [options]="this.options" [title]="''" placeholder="Ingrese la dirección" #placesRef="ngx-places" (onAddressChange)="handleAddressChange($event)" />
                            </div>
                            <mat-icon class="inputbuscadoricono" (click)="UbicarControlBuscador()">search</mat-icon>
                        </div>
                    </div>
                </div>
            </div>

            <div class="d-flex flex-column">
                <div class="d-flex flex-row">
                    <div class="contenedorcirculocobertura">
                    </div>
                    <div>
                        <p class="textodescriptivocobertura">Zona de prestación del servicio</p>
                    </div>
                </div>
                <div class="d-flex flex-row">
                    <div class="contenedorcirculonocobertura">
                    </div>
                    <div>
                        <p class="textodescriptivocobertura">Zona de operación de reembolso</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div #contenedorprincipal class="buscadormapa">
        <google-map #maps [width]="(contenedorprincipal.offsetWidth + 5)" [center]="mapCenter" [options]="mapOptions" [zoom]="this.zoomOption">
            <map-polygon [paths]="item.listaPoligono" [options]="item.opcionesPoligono" *ngFor="let item of listaCiudades">
            </map-polygon>
            <map-marker #marker="mapMarker" [position]="mapCenter" [options]="markerOptions">
            </map-marker>
        </google-map>
        <button class="botonregistrar" (click)="RegistrarUbicacion()">
            Registrar
        </button>
    </div>
</div>